import { motion, useReducedMotion } from "framer-motion";

export const PageHero = ({ eyebrow, title, children, testId = "page-hero" }) => {
  const reduce = useReducedMotion();
  return (
    <header className="px-4 pb-12 pt-16 sm:px-8 sm:pb-16 sm:pt-24 lg:px-16" data-testid={testId}>
      <div className="mx-auto max-w-4xl">
        {eyebrow && (
          <p className="mb-4 text-xs font-semibold uppercase tracking-[0.25em] text-gold-dark sm:text-sm">
            {eyebrow}
          </p>
        )}
        <motion.h1
          initial={reduce ? false : { opacity: 0, y: 28 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.215, 0.61, 0.355, 1] }}
          className="font-serif text-4xl font-light leading-[1.12] tracking-tight text-ink sm:text-5xl lg:text-6xl"
        >
          {title}
        </motion.h1>
        {children && (
          <div className="mt-6 max-w-2xl text-lg leading-relaxed text-body sm:text-xl">
            {children}
          </div>
        )}
      </div>
    </header>
  );
};
